"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _PushMessageCreation = require("@/api/messagePush/PushMessageCreation");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      queryData: {
        messageType: '',
        timeType: '',
        starTime: '',
        status: '',
        endTime: '',
        page: 1,
        size: 10
      },
      tableData: [],
      total: 0 // 条数
    };
  },
  created: function created() {
    this.listMessagePlan();
  },
  methods: {
    listMessagePlan: function () {
      var _listMessagePlan2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _PushMessageCreation.listMessagePlan)(params);
            case 1:
              res = _context.v;
              if (res.code === 0) {
                console.log(res.data);
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function listMessagePlan() {
        return _listMessagePlan2.apply(this, arguments);
      }
      return listMessagePlan;
    }(),
    delRecord: function delRecord(id) {
      var _this = this;
      this.$confirm('是否确认删除此推送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.deleteMessagePlan(id);
      });
    },
    deleteMessagePlan: function () {
      var _deleteMessagePlan2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = {
                messageLanConfigId: id
              };
              _context2.n = 1;
              return (0, _PushMessageCreation.deleteMessagePlan)(params);
            case 1:
              res = _context2.v;
              if (res.data) {
                this.$message.success('删除成功');
                this.listMessagePlan();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function deleteMessagePlan(_x) {
        return _deleteMessagePlan2.apply(this, arguments);
      }
      return deleteMessagePlan;
    }(),
    // 查询
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listMessagePlan();
    },
    // 重置
    onInitialize: function onInitialize() {
      this.onInit();
      this.listMessagePlan();
    },
    onInit: function onInit() {
      this.queryData = {
        messageType: '',
        timeType: '',
        starTime: '',
        endTime: '',
        page: 1,
        size: 10
      };
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listMessagePlan();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listMessagePlan();
    }
  }
};